import { useLayoutEffect, useState } from 'react'
import { Html } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { useExpedition } from '../store/useExpedition.js'

const localDepth = 19.2 * 3.2
const marks = [
  { name:'Boulder Ventures', detail:'1941 Pearl Street · Suite 300', u:.532667, v:.498462, office:true },
  { name:'Chautauqua', detail:'Trailhead · 5,686 ft', u:.45533, v:.62815 },
  { name:'First Flatiron', detail:'Fountain Formation', u:.3856, v:.66785 },
  { name:'Green Mountain', detail:'8,148 ft', u:.32047, v:.74799 },
]

export function Landmarks() {
  const scene = useThree(state=>state.scene)
  const [positions,setPositions] = useState([])
  const activeEssay = useExpedition(state=>state.activeEssay)
  useLayoutEffect(()=>{
    const terrain=[]
    scene.traverse(object=>{if(object.isMesh&&object.userData.terrainSurface) terrain.push(object)})
    if(!terrain.length) return
    scene.updateMatrixWorld(true)
    const raycaster=new THREE.Raycaster()
    raycaster.ray.direction.set(0,-1,0)
    setPositions(marks.map(mark=>{
      const x=(mark.u-.5)*64
      const z=-8.4+(mark.v-.5)*localDepth
      raycaster.ray.origin.set(x,80,z)
      const hit=raycaster.intersectObjects(terrain,false)[0]
      return [x,(hit?.point.y ?? -4)+.04,z]
    }))
  },[scene])
  if(activeEssay||positions.length!==marks.length) return null
  return <group>{marks.map((mark,index)=><group key={mark.name} position={positions[index]}>
    <mesh position={[0,.45,0]}><cylinderGeometry args={[.012,.012,.9,5]}/><meshBasicMaterial color="#f1d39b"/></mesh>
    <mesh position={[0,.92,0]}><octahedronGeometry args={[mark.office?.14:.09,0]}/><meshBasicMaterial color={mark.office?'#fac832':'#cf754a'}/></mesh>
    <Html position={[0,1.22,0]} center distanceFactor={10} className="landmark-label"><strong>{mark.name}</strong><span>{mark.detail}</span></Html>
  </group>)}</group>
}
